// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { GridContainerProps } from "@store/MobiusOverrides/GridContainer/GridContainer";
import Img, { ImgProps } from "@store/MobiusOverrides/Img/Img";
import constants from "@store/constants";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    page: getCurrentPage(state),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface BlogPageAuthorStyles {
    dateAndAuthorWrapper?: InjectableCss;
    dateAndAuthorContainedWrapper?: InjectableCss;
    dateAndAuthorContainer?: GridContainerProps;
    authorImageWrapper?: ImgProps;
    authorImage?: InjectableCss;
    authorNameText?: TypographyProps;
    authorNameWrapper?: InjectableCss;
    authorTitleText?: TypographyProps;
    publishDateText?: TypographyProps;
}

export const blogPageAuthorStyles: BlogPageAuthorStyles = {
    dateAndAuthorWrapper: {
        css: css`
            background-color: ${getColor("common.accent")};
        `,
    },
    dateAndAuthorContainedWrapper: {
        css: css`
            ${siteWidthStyles()}
        `,
    },
    dateAndAuthorContainer: {
        css: css`
            display: flex;
            padding: ${pxToRem(24, 0)};
        `,
    },
    authorImageWrapper: {
        css: css`
            margin-right: ${pxToRem(8)};
        `,
    },
    authorImage: {
        css: css`
            max-width: ${pxToRem(100)};
            max-height: ${pxToRem(100)};
            width: auto;
            height: auto;
            align-items: center;

            ${breakpoint("md")} {
                max-width: ${pxToRem(150)};
                max-height: ${pxToRem(150)};
            }
        `,
    },
    authorNameWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
        `,
    },
    authorNameText: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.large};
            font-weight: ${x => x.theme.design.typography.weight.bold};

            ${breakpoint("md")} {
                font-size: ${x => x.theme.design.typography.size.larger};
            }
        `,
    },
    authorTitleText: {
        color: "primary",
        css: css`
            font-size: ${x => x.theme.design.typography.size.small};
            margin-bottom: ${pxToRem(8)};

            ${breakpoint("md")} {
                font-size: unset;
            }
        `,
    },
};

const styles = blogPageAuthorStyles;

const BlogPageAuthor = ({ page }: Props) => {
    if (!page) {
        return null;
    }

    const {
        fields: { authorImage, authorName, authorTitle, publishDate },
    } = page;

    return (
        <StyledWrapper {...styles.dateAndAuthorWrapper}>
            <StyledWrapper {...styles.dateAndAuthorContainedWrapper}>
                <StyledWrapper {...styles.dateAndAuthorContainer}>
                    {authorImage && (
                        <StyledWrapper {...styles.authorImageWrapper}>
                            <Img {...styles.authorImage} src={authorImage} />
                        </StyledWrapper>
                    )}
                    <StyledWrapper {...styles.authorNameWrapper}>
                        {authorName && <Typography {...styles.authorNameText}>{authorName}</Typography>}
                        {authorTitle && <Typography {...styles.authorTitleText}>{authorTitle}</Typography>}
                        {publishDate && (
                            <Typography {...styles.publishDateText}>
                                <LocalizedDateTime
                                    dateTime={new Date(publishDate)}
                                    options={{ year: "numeric", month: "long", day: "numeric" }}
                                />
                            </Typography>
                        )}
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(BlogPageAuthor),
    definition: {
        group: constants.widgetGroup.blogPage,
        allowedContexts: [constants.pageType.blogPost] as any,
    },
};

export default widgetModule;
